import React, { Component } from "react";
import { MdOutlineContentCopy } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

class TeamInviteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
  }

  copyLinkToClipboard = () => {
    const { invitationLink } = this.props;

    navigator.clipboard
      .writeText(invitationLink)
      .then(() => {
        this.setState({ copied: true });
        toast.success("Link copied to clipboard!", {
          position: "top-right",
          autoClose: 3000,
        });

        // Reset copied state after 3 seconds
        setTimeout(() => {
          this.setState({ copied: false });
        }, 3000);
      })
      .catch(err => {
        toast.error("Failed to copy link", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  handleCloseClick = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  redirectToClan = () => {
    const { clanId } = this.props;
    if (clanId) {
      window.open(`/clan/view/${clanId}`, "_blank");
    } else {
      toast.error("Clan ID not available", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  redirectToTeam = () => {
    const { clanId, teamId } = this.props;
    if (teamId && clanId) {
      window.open(`/clan/team/view/${teamId}`, "_blank");
    } else {
      toast.error("Team ID not available", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  render() {
    const { invitationLink, teamName, clanId, teamId } = this.props;
    const { copied } = this.state;

    return (
      <div className="invite-content p-4 position-relative">
        {/* Close Button */}
        <IoIosCloseCircleOutline
          className="close-icon position-absolute"
          style={{ right: "25px", top: "20px" }}
          onClick={this.handleCloseClick}
        />

        <h5 className="text-heading fs-18 fw-bold text-white text-center mb-2">Invite</h5>

        {invitationLink ? (
          <div className="invite-content mb-4">
            <p className="text-center text-white fs-14 fw-500 mb-4">
              You can invite the players for <span className="fw-bold">{teamName}</span> by sharing
              the given link below.
            </p>

            <p className="text-center text-white fs-18 fw-600 mb-4">
              Complete your team to unlock tournament registration!
            </p>

            <p className="fs-16 fw-600 text-white mb-1">Copy Link</p>
            <div className="d-flex align-items-center position-relative">
              <input
                type="text"
                autoComplete="off"
                className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                value={invitationLink}
                readOnly
                style={{ paddingRight: "45px" }}
              />
              <MdOutlineContentCopy
                className={`copy-icon me-3 position-absolute ${
                  copied ? "text-success" : "text-white"
                }`}
                style={{ right: "10px", cursor: "pointer", fontSize: "20px" }}
                onClick={this.copyLinkToClipboard}
              />
            </div>
          </div>
        ) : (
          <div className="invite-content mb-4">
            <p className="text-center text-white fs-14 fw-500 mb-4">
              Generating invite link for <span className="fw-bold">{teamName}</span>...
            </p>
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        )}

        <div className="text-center">
          {invitationLink && (
            <div className="mb-3">
              <Button
                onClick={this.copyLinkToClipboard}
                variant="light"
                className="fw-bold py-2 px-5 m-auto"
              >
                {copied ? "Copied!" : "Copy Link"}
              </Button>
            </div>
          )}

          <div className="mt-3 mb-3 d-flex justify-content-center gap-3">
            {clanId && (
              <Button
                onClick={this.redirectToClan}
                variant="outline-primary"
                className="fw-bold py-2 px-4"
              >
                Manage Clan
              </Button>
            )}

            {teamId && (
              <Button
                onClick={this.redirectToTeam}
                variant="outline-primary"
                className="fw-bold py-2 px-4"
              >
                Manage Team
              </Button>
            )}
          </div>

          {invitationLink && (
            <p className="text-center text-white fs-14 fw-500 mt-3">
              Share this link with your squad to assemble your dream team and dominate the
              tournament!
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default TeamInviteModal;
